import classNames from "classnames";
import { Col, Image, Row } from "react-bootstrap";
import { URLS } from "../../../commun/routes.tsx";
import Footer from "../../../commun/components/Footer/Footer.tsx";
import imgFameFamirea from "../../../images/commun/Fame_par_Famirea_Financeur.png";
import { MainContent } from "../../../app/components/Elements/Elements.tsx";
import url from "../../../app/module/fetch.tsx";
import {
  LinkButton,
  VARIANTS,
} from "../../../app/components/Button/Button.tsx";
import LigneEcoute from "../../../commun/components/LigneEcoute/LigneEcoute.tsx";
import {
  IconFileDownload,
  IconUser,
} from "../../../app/components/Icon/Icon.tsx";
import { CodeLivretAccueil } from "../../../commun/GlobalConstants.tsx";
import LivretAccueilRessource from "../../../app/pages/Ressources/LivretAccueilRessource.tsx";
import imageLigneEcoute from "../../../images/accueil/ligne_ecoute.png";
import styles from "./Accueil.module.css";

const Accueil = () => {
  return (
    <>
      <header
        className={classNames(
          "position-relative m-0 p-0",
          styles.enteteAccueil,
        )}
      >
        <Row className="pt-3 m-0">
          <Col
            xs={12}
            md={8}
            lg={6}
            className={classNames(styles.imgFameFamirea, "text-nowrap")}
          >
            <Image src={imgFameFamirea} alt="Logos Fame et Famirea" fluid />
          </Col>
          <Col xs="auto" className={"ms-auto"}>
            <a
              href={URLS.LOGIN}
              className={
                "btn btn-light rounded-pill text-dark d-flex align-items-center"
              }
            >
              <span
                className={
                  "col-auto bg-primary px-3 py-2 rounded-pill align-items-center text-light fw-bold"
                }
              >
                <IconUser />
              </span>
              <span
                className={classNames(
                  "col-auto ms-2 align-items-center text-uppercase",
                  styles.login,
                )}
              >
                CONNEXION
              </span>
            </a>
          </Col>
        </Row>
        <section className={"row m-0 ms-5"}>
          <div className="col-xs-12 col-md-10 col-lg-5">
            <h1
              className={classNames(
                "text-uppercase mb-0 text-light fw-bold",
                styles.titreAccueil,
              )}
            >
              FAME
            </h1>
            <p
              className={classNames(
                "text-light fs-5 mt-0 fw-bold",
                styles.sousTitreAccueil,
              )}
            >
              Améliorer l’expérience des familles et des proches des patients
              hospitalisés en réanimation
            </p>
          </div>
        </section>
      </header>
      <MainContent>
        <main className={"mt-200"}>
          <section className={"row top-0 my-3"}>
            <div
              className={"card rounded-5 col-xs-12 col-xl-10 mx-auto bg-light"}
            >
              <div className="card-body m-3">
                <h2
                  className={classNames(
                    "card-title text-primary h1 mb-5",
                    styles.firstCardTitle,
                  )}
                >
                  FAME : un projet du groupe Famiréa
                </h2>
                <p className={"my-5 fs-5 fw-lighter"}>
                  Famiréa est un groupe de recherche pluridisciplinaire dont les
                  études portent essentiellement sur l’
                  <b>
                    expérience des familles et des proches de patients
                    hospitalisés en service de réanimation
                  </b>
                  , ainsi que celles des patients, des médecins et des soignants
                  paramédicaux.
                </p>
                <p className={"my-5 fs-5 fw-lighter"}>
                  Le groupe développe une recherche pragmatique dans le but de
                  mieux <b>penser le soin et l’accompagnement</b> depuis plus de
                  25 ans.
                </p>
                <p className={"my-5 fs-5 fw-lighter"}>
                  FAME est un projet de recherche porté par l’Agence Nationale
                  de la Recherche et piloté par l’Université Paris Cité,
                  associant 61 services de réanimation.
                </p>
              </div>
            </div>
          </section>
          <section className={"mt-5"}>
            <div className="card col-xs-12 col-xl-10 mx-auto bg-light bg-transparent border-0">
              <div className="row g-0">
                <div className="col-3 me-3">
                  <img
                    src={imageLigneEcoute}
                    className="img-fluid rounded-5 "
                    alt="..."
                  />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5
                      className={classNames("card-title text-primary h1 mb-5")}
                    >
                      Ligne d&apos;écoute Famiréa
                    </h5>
                    <p className={"my-4 fs-5 fw-lighter"}>
                      Cette ligne téléphonique nationale <b>gratuite</b>{" "}
                      s’adresse aux{" "}
                      <b>
                        proches de patients hospitalisés ou ayant été
                        hospitalisés en réanimation
                      </b>
                      .
                    </p>
                    <p className={"my-4 fs-5 fw-lighter"}>
                      Elle a pour vocation de proposer une écoute{" "}
                      <b>active et bienveillante</b>.
                    </p>
                    <div className={"" /*styles.secondCardPhoneDiv*/}>
                      <LigneEcoute />
                    </div>
                    <p className={"my-4 fs-5 fw-lighter"}>
                      Vous êtes un proche de patient hospitalisé ou ayant été
                      hospitalisé en réanimation ?{" "}
                      <b>N’hésitez pas à appeler si vous avez besoin !</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className={"row mt-5"}>
            <div
              className={"card rounded-5 col-xs-12 col-xl-10 mx-auto bg-light"}
            >
              <div className="card-body m-3">
                <h2
                  className={classNames(
                    "card-title text-primary h1 mb-5 text-center",
                  )}
                >
                  Consultez le livret d&apos;accueil Famiréa
                </h2>
                <LivretAccueilRessource />
                <div className={"text-center mt-2"}>
                  <LinkButton
                    variant={VARIANTS.secondary}
                    href={
                      url`/api/public/ressource/telecharger-ressource/` +
                      CodeLivretAccueil
                    }
                  >
                    Télécharger le livret d&apos;accueil <IconFileDownload />
                  </LinkButton>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </MainContent>
    </>
  );
};

export default Accueil;
